import routes from './routes'
import Vue from 'vue'
import Router from 'vue-router'
import Default from '@/layouts/Default.vue'
import { isAuthenticated, login } from '@/auth/auth'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: Default,
      children: routes,
    },
  ],
})

// Нет токена → уводим на SSO за ним. В local-окружении VUE_APP_AUTH_SERVICE пуст
// и бэк отдаёт dev-юзера без токена, поэтому гард там не мешает.
router.beforeEach((to, from, next) => {
  if (!isAuthenticated() && process.env.VUE_APP_AUTH_SERVICE) {
    login()

    return
  }

  next()
})

export default router
